import * as React from "react";
const SvgRightChevrolet = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 9, viewBox: "0 0 6 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.5 0L0.442505 1.0575L3.8775 4.5L0.442505 7.9425L1.5 9L6 4.5L1.5 0Z", fill: "#FF6000" }));
export default SvgRightChevrolet;
